import { BillingAccountBlock } from "@/admin/accounts/BillingAccountBlock.tsx";
import { DocumentTypeLabel, ReportType } from "@/admin/reports/ReportComponents.tsx";
import { invoiceQueryAtom } from "@/admin/reports/reportsQuery.ts";
import type { GQInvoiceItem } from "@/admin/reports/ReportsTable.tsx";
import { LongDate } from "@/components/l10n/DateFormat.tsx";
import { Separator } from "@/components/Separator.tsx";
import { DetailsTableRow } from "@/components/table/DetailsTableRow.tsx";
import { InvoiceDetails, ServicesContent } from "@/modules/billing/invoice/InvoiceView.tsx";
import { useSuspenseQueryAtom } from "@/utils/query/useSuspenseQueryAtom.ts";
import { apiUnixToDate } from "@warrenio/api-spec/conversion";
import type { BillingAccountInvoice, InvoiceStatus } from "@warrenio/api-spec/spec.oats.gen";
import { notNull } from "@warrenio/utils/notNull";

export function InvoiceDetailView({ item }: { item: GQInvoiceItem }) {
    const data: BillingAccountInvoice = useSuspenseQueryAtom(invoiceQueryAtom(item.id));

    const invoice: BillingAccountInvoice = {
        ...data,
        status: notNull(item.status) as InvoiceStatus,
    };
    const billingAccount = notNull(item.billing_account);
    const { document_type, type, created } = invoice;

    return (
        <>
            <InvoiceDetails invoice={invoice} accountCell={<BillingAccountBlock showId value={billingAccount} />}>
                <DetailsTableRow title="Document type">
                    <DocumentTypeLabel value={document_type} />
                </DetailsTableRow>

                <DetailsTableRow title="Report type">
                    <ReportType value={type} />
                </DetailsTableRow>

                {created && (
                    <DetailsTableRow title="Created">
                        <LongDate date={apiUnixToDate(created)} />
                    </DetailsTableRow>
                )}
            </InvoiceDetails>
            <Separator />
            <ServicesContent invoice={invoice} />
        </>
    );
}
